<svg
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 550.801 550.801"
  style="enable-background: new 0 0 550.801 550.801"
  xml:space="preserve"
>
  <g>
    <path
      d="M488.426,197.019H475.2v-63.816c0-0.401-0.063-0.799-0.116-1.205c-0.021-2.534-0.827-5.023-2.562-6.992L366.325,3.691
		c-0.032-0.031-0.063-0.042-0.085-0.073c-0.633-0.707-1.371-1.298-2.151-1.804c-0.231-0.158-0.464-0.287-0.706-0.422
		c-0.676-0.366-1.393-0.675-2.131-0.896c-0.2-0.053-0.38-0.135-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
		c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.87v160.542
		c0,17.044,13.824,30.876,30.873,30.876h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
		V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87V227.89C519.297,210.838,505.47,197.019,488.426,197.019z M97.2,21.605
		h250.193v110.51c0,5.967,4.841,10.8,10.8,10.8h95.407v54.108H97.2V21.605z M373.792,365.091h-26.246l-1.771-45.457
		c-0.532-14.27-1.039-31.551-1.039-48.818h-0.543c-3.707,15.158-8.633,32.081-13.215,46.003l-14.449,46.348h-20.973l-12.688-46
		c-3.876-13.933-7.926-30.828-10.739-46.351h-0.366c-0.696,16.033-1.236,34.364-2.102,49.167l-2.123,45.108h-24.848l7.58-118.76
		h35.762l11.623,39.643c3.702,13.742,7.404,28.545,10.051,42.467h0.518c3.354-13.742,7.414-29.426,11.285-42.641l12.688-39.464
		h35.068L373.792,365.091z M79.872,246.331h28.708l8.983,48.982c2.647,14.091,5.115,29.432,7.059,41.407h0.356
		c1.917-12.856,4.759-27.137,7.744-41.755l10.048-48.634h28.551l9.516,50.047c2.634,13.922,4.567,26.61,6.339,39.819h0.346
		c1.771-13.209,4.395-27.131,6.884-41.232l9.682-48.634h27.309l-30.66,118.76h-29.08l-10.038-51.089
		c-2.299-11.997-4.219-23.093-5.632-36.661h-0.346c-2.123,13.39-4.071,24.664-6.874,36.661l-11.274,51.089h-29.437L79.872,246.331z
		 M453.601,523.353H97.2V419.302h356.4V523.353z M453.812,365.091h-31.366l-38.054-118.755h29.426l14.438,50.216
		c4.051,14.086,7.752,27.67,10.568,42.468h0.549c2.984-14.275,6.687-28.382,10.736-41.945l15.156-50.738h28.539L453.812,365.091z"
    />
  </g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
</svg>
